export const FETCH_NAME = 'UserPage/FETCH_NAME';
export const FETCH_NAME_ERROR = 'UserPage/FETCH_NAME_ERROR';
export const FETCH_NAME_SUCCESS = 'UserPage/FETCH_NAME_SUCCESS';



// WEBPACK FOOTER //
// client/containers/UserPage/constants.js